import { validateIcon } from '../asset-icon/validate-icon';

export interface IIconMatch {
  code: string;
  file: File;
}

export interface IRejectedIcon {
  file: File;
  reason: string;
}

export interface IIconMatchResult {
  matched: IIconMatch[];
  unmatched: File[];
  withoutIcon: string[];
  rejected: IRejectedIcon[];
}

const stemOf = (name: string): string => {
  const lastDot = name.lastIndexOf('.');
  return lastDot > 0 ? name.slice(0, lastDot) : name;
};

const normalise = (value: string): string => value.trim().toLowerCase();

const isOsNoise = (name: string): boolean => name.startsWith('.');

export const matchIconFiles = (files: File[], codes: string[]): IIconMatchResult => {
  const byNormalisedCode = new Map<string, string>();
  codes.forEach((code) => {
    const key = normalise(code);
    if (key !== '' && !byNormalisedCode.has(key)) {
      byNormalisedCode.set(key, code);
    }
  });

  const matched: IIconMatch[] = [];
  const unmatched: File[] = [];
  const rejected: IRejectedIcon[] = [];
  const taken = new Map<string, string>();

  [...files]
    .filter((file) => !isOsNoise(file.name))
    .sort((left, right) => left.name.localeCompare(right.name))
    .forEach((file) => {
      const check = validateIcon(file);
      if (!check.ok) {
        rejected.push({ file, reason: check.reason });
        return;
      }

      const key = normalise(stemOf(file.name));
      const code = byNormalisedCode.get(key);
      if (code === undefined) {
        unmatched.push(file);
        return;
      }

      const already = taken.get(key);
      if (already !== undefined) {
        rejected.push({ file, reason: `${already} already has an icon in this selection` });
        return;
      }

      taken.set(key, file.name);
      matched.push({ code, file });
    });

  return {
    matched,
    unmatched,
    rejected,
    withoutIcon: codes.filter((code) => !taken.has(normalise(code))),
  };
};
